export default __webpack_public_path__ + "static/media/arrow-left-white.7b103870.svg";